import React, { useState, useEffect } from 'react';
import { auth, provider, signInWithPopup, signOut } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import logo from "./assets/logo.png";
import swatiImage from "./assets/swati.jpeg";
import { db } from './firebase';
import {
  getDoc,
  doc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";


const coursesData = [
    {
      id: 1,
      title: "NORCET 2025 Crash Course",
      description: "A high-yield intensive course to help you crack NORCET 2025 with confidence and speed.",
      longDescription: "This crash course is tailor-made for NORCET 2025 aspirants. It includes rapid revision sessions, mock tests, frequently asked questions, and core concept brushing — all packed into a focused and fast-paced format.",
      image: "https://placehold.co/600x400/81e6d9/2d3748?text=NORCET+Crash",
      youtubeVideoId: "QPDd_L222o4"
    },
    {
      id: 2,
      title: "Gynecology",
      description: "Master OBGYN topics with visual explanations, key facts, and clinical case scenarios.",
      longDescription: "This course focuses on all major areas of gynecology including reproductive health, menstrual disorders, pregnancy care, and labor management. Designed for both freshers and those revising high-yield gyne topics.",
      image: "https://placehold.co/600x400/a7f3d0/2d3748?text=Gynecology",
      youtubeVideoId: "gufy4i7pU_A"
    },
    {
      id: 3,
      title: "Pediatrics",
      description: "Learn pediatric nursing with real-world case studies, developmental milestones, and emergency care.",
      longDescription: "This course covers essential pediatric care — from newborn assessments to common childhood illnesses and emergencies. It simplifies growth charts, vaccinations, pediatric drug dosing, and includes real-life examples.",
      image: "https://placehold.co/600x400/bae6fd/2d3748?text=Pediatrics",
      youtubeVideoId: "7le62_B-9_g"
    },
  ];


  const Header = ({ setView }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showEnrollForm, setShowEnrollForm] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
  
    const handleNavClick = (view) => {
      setView(view);
      setIsMenuOpen(false);
    };
  
    const handleEnrollSubmit = async (e) => {
      e.preventDefault();
      try {
        await setDoc(doc(db, "enrollments", email.toLowerCase().trim()), {
          name,
          email,
          created_at: serverTimestamp()
        });
        alert("Enrollment submitted successfully!");
        setShowEnrollForm(false);
        setName('');
        setEmail('');
      } catch (error) {
        console.error("Error submitting enrollment:", error);
        alert("Failed to submit enrollment.");
      }
    };
  
    return (
      <>
        <header className="bg-white shadow-md sticky top-0 z-50">
          <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
            <button onClick={() => handleNavClick('home')} className="flex items-center space-x-3">
              <img src={logo} alt="Logo" className="w-14 h-14 object-contain" />
              <span className="text-2xl font-bold text-cyan-600">Nursing with Swati</span>
            </button>
            <div className="hidden md:flex items-center space-x-6">
              <button onClick={() => handleNavClick('home')} className="text-gray-600 hover:text-cyan-500 transition duration-300">Home</button>
              <a href="#about" onClick={() => handleNavClick('home')} className="text-gray-600 hover:text-cyan-500 transition duration-300">About</a>
              <a href="#contact" onClick={() => handleNavClick('home')} className="text-gray-600 hover:text-cyan-500 transition duration-300">Contact</a>
              <button onClick={() => setShowEnrollForm(true)} className="bg-cyan-500 text-white px-4 py-2 rounded-full hover:bg-cyan-600 transition duration-300">Enroll Now</button>
            </div>
          </nav>
        </header>
  
        {showEnrollForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
              <h2 className="text-xl font-bold mb-4">Student Enrollment</h2>
              <form onSubmit={handleEnrollSubmit} className="space-y-4">
                <div>
                  <label className="block mb-1 font-medium text-sm">Full Name</label>
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:border-cyan-500" required />
                </div>
                <div>
                  <label className="block mb-1 font-medium text-sm">Email</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:border-cyan-500" required />
                </div>
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={() => setShowEnrollForm(false)} className="text-gray-600 hover:text-gray-800">Cancel</button>
                  <button type="submit" className="bg-cyan-600 text-white px-4 py-2 rounded hover:bg-cyan-700">Submit</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  };
  

const Hero = () => (
    <section className="relative py-32 bg-blue-50 overflow-hidden">
      {/* Subtle Background Text */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
      <h1 className="text-[200px] text-blue-100 opacity-50 font-bold whitespace-nowrap leading-none">
        Caring Hands
      </h1>
    </div>


      {/* Foreground Hero Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6">
          Master Nursing with Confidence
        </h1>
        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-10">
          Join Swati, an experienced nursing educator, for engaging video courses designed to help you excel in your exams and clinical practice.
        </p>
        <a
          href="#courses"
          className="bg-cyan-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-cyan-600 transition duration-300 transform hover:scale-105 inline-block"
        >
          Explore Courses
        </a>
      </div>
    </section>
  );




const CourseList = ({ courses, onCourseSelect }) => (
  <section id="courses" className="py-20 bg-white">
    <div className="container mx-auto px-6">
    <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">Featured Free Video Courses</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {courses.map(course => (
          <div key={course.id} className="bg-gray-50 rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-all duration-300 flex flex-col">
            <img src={course.image} alt={course.title} className="w-full h-48 object-cover" />
            <div className="p-6 flex flex-col flex-grow">
              <h3 className="text-xl font-bold text-cyan-700 mb-2">{course.title}</h3>
              <p className="text-gray-600 mb-4 flex-grow">{course.description}</p>
              <button onClick={() => onCourseSelect(course)} className="font-semibold text-cyan-600 hover:text-cyan-700 self-start">
                Enroll to Watch Now <i className="fas fa-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const CourseDetail = ({ course, onBack }) => (
  <div className="bg-gray-50 py-12">
    <div className="container mx-auto px-6">
      <button onClick={onBack} className="mb-8 inline-flex items-center text-cyan-600 hover:text-cyan-800 font-semibold transition-colors duration-300">
        <i className="fas fa-arrow-left mr-2"></i> Back to All Courses
      </button>
      <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl">
        <div className="aspect-w-16 aspect-h-9 mb-8 rounded-lg overflow-hidden shadow-md">
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${course.youtubeVideoId}?autoplay=1&rel=0`}
            title={course.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">{course.title}</h1>
        <p className="text-gray-600 text-lg leading-relaxed">{course.longDescription}</p>
      </div>
    </div>
  </div>
);


const About = () => (
  <section id="about" className="py-16 bg-cyan-50">
    <div className="container mx-auto px-6 flex flex-col md:flex-row items-center gap-12">
      <div className="md:w-1/3 text-center">
        <img
          src={swatiImage}
          alt="Swati - Nursing Instructor"
          className="rounded-full shadow-xl w-48 h-48 object-cover mx-auto"
        />
      </div>
      <div className="md:w-2/3">
        <h2 className="text-4xl font-bold text-gray-800 mb-6">About Swati</h2>
        <p className="text-lg text-gray-700 mb-4 leading-relaxed">
          Swati is a passionate and dedicated Registered Nurse (RN) with over 3+ years of experience in both clinical settings and academic instruction. After seeing countless students struggle with complex topics, she decided to create "Nursing with Swati" to make learning accessible, engaging, and effective.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed">
          Her teaching philosophy centers on breaking down difficult concepts into easy-to-understand modules, using real-world examples and a supportive approach. Swati is committed to empowering the next generation of nurses to be competent, confident, and compassionate caregivers.
        </p>
      </div>
    </div>
  </section>
);


const Contact = () => (
    <section id="contact" className="bg-gray-900 text-white py-12 text-center">
        <div className="container mx-auto px-6">
        <h2 className="text-xl font-semibold mb-2">Nursing with Swati</h2>
        <p className="mb-4">© 2025. All Rights Reserved.</p>
        <div className="flex justify-center space-x-6 text-gray-400">
            <a href="mailto:nursing.swati@example.com" target="_blank" rel="noreferrer" className="hover:text-white">📧 Email</a>
            <a href="https://instagram.com/nursingwithswati" target="_blank" rel="noreferrer" className="hover:text-white">📸 Instagram</a>
            <a href="https://youtube.com/@nursingwithswati" target="_blank" rel="noreferrer" className="hover:text-white">▶️ YouTube</a>
        </div>
        </div>
    </section>
);

export default function App() {
  const [view, setView] = useState('home');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [user] = useAuthState(auth);

  const handleCourseSelect = (course) => setSelectedCourse(course);
  const handleBack = () => setSelectedCourse(null);
  const handleLogout = () => signOut(auth);

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const docRef = doc(db, "enrollments", user.email.toLowerCase().trim());
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        alert("You are not enrolled. Please enroll first.");
        await signOut(auth);
      }
    } catch (err) {
      console.error("Login failed:", err);
      alert("Login error");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view]);

  return (
    <div className="bg-gray-50 text-gray-800 font-sans">
      <div className="text-right p-4">
        {user ? (
          <div>
            <span className="mr-4">Welcome, {user.displayName}</span>
            <button onClick={handleLogout} className="bg-red-500 text-white px-3 py-1 rounded">
              Logout
            </button>
          </div>
        ) : (
          <button onClick={handleLogin} className="bg-cyan-600 text-white px-4 py-2 rounded">
            Login with Google
          </button>
        )}
      </div>
      <Header setView={setView} />
      <main>
        {view === 'home' && (
          <>
            <Hero />
            <CourseList courses={coursesData} onCourseSelect={handleCourseSelect} />
            <About />
            <Contact />
          </>
        )}
        {view === 'courseDetail' && selectedCourse && (
          <CourseDetail course={selectedCourse} onBack={handleBack} />
        )}
      </main>
    </div>
  );
}

